<div class="crp-container" [class.complicate]="typeAsImageName" (click)="onSwitchIcon()">
  <img class="crp" src="{{ iconPath | xviSourcePath }}" />
  <span class="crp-text" *ngIf="showCaption && caption && isCollapsed">{{
    caption | async | translate
  }}</span>
</div>
